import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ServicesShowcase from "./sections/ServicesShowcase";
import Fleet from "./sections/Fleet";
import FlatRate from "./sections/FlatRate";
import Coverage from "./sections/Coverage";
import Principles from "./sections/Principles";
import Feedback from "./sections/Feedback";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <ServicesShowcase />
      <Fleet />
      <FlatRate />
      <Coverage />
      <Principles />
      <Feedback />
      <Cta />
      <Footer />
    </div>;
}